module.exports = __webpack_public_path__ + "static/img/01.0ad7222.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/04/01.jpg
// module id = OUn9
// module chunks = 0